import Calendar from "react-calendar";
import { useAppState } from "../../providers/app-state";
import dayjs from "dayjs";
import Skeleton from 'react-loading-skeleton';

const SkgCalendar = ({ disabledDates, loading }) => {
    const { state, dispatch } = useAppState();

    if (loading) {
        return (
            <Skeleton
                className="h-72"
            />
        )
    }

    return (
        <div
            className="flex flex-1 basis-full flex-wrap shadow-md"
        >
            <div
                className="bg-skgBlue basis-full xl:basis-1/4 rounded-t-md xl:rounded-tr-none xl:rounded-l-md  py-4 text-white flex items-center flex-row xl:flex-col px-3"
            >
                <div
                    className="flex flex-row flex-wrap"
                >
                    <p
                        className="text-gray-400 basis-full"
                    >
                        {state.selectedDate.year()}
                    </p>
                    <p
                        className="text-3xl mr-3"
                    >
                        {state.selectedDate.locale("da").format("ddd")}
                    </p>
                    <p
                        className="text-3xl"
                    >
                        {state.selectedDate.locale("da").format("MMM D")}
                    </p>
                </div>
            </div>
            <div
                className="p-2 rounded-r-md bg-white basis-full xl:basis-3/4"
            >
                <Calendar
                    value={state.selectedDate.toDate()}
                    locale="da-DK"
                    minDetail="month"
                    minDate={dayjs().add(1, 'day').toDate()}
                    tileDisabled={({ date }) => {
                        const dateObj = dayjs(date);
                        if (dateObj.day() === 6 || dateObj.day() === 0) {
                            return true;
                        }
                        return disabledDates.some(item => dateObj.isSame(item.date, 'date'))
                    }}
                    onChange={date => {
                        dispatch({
                            key: "selectedDate",
                            value: dayjs(date)
                        })
                    }}
                    onClickMonth={() => alert("dada")}
                />
            </div>
        </div>
    )
}

export default SkgCalendar;